import { createElement } from "./SchemaSettings";

function applyThemeLayerToPage(page, category, themeRegistry) {
  const newPage = JSON.parse(JSON.stringify(page));

  newPage.sections.forEach(section => {
    section.contents.forEach(container => {
      container.cards.forEach(card => {
        card.elements.forEach(element => {
          const role = element.styleRole;
          const rules = themeRegistry[category]?.[role];
          if (!rules) return;

          element.styles.theme = {
            ...element.styles.theme,
            ...rules,
          };
        });
      });
    });
  });

  return newPage;
}


export function applyTypographyToPage(page, themeRegistry) {
  return applyThemeLayerToPage(page, "typography", themeRegistry);
}

export function applyColorsToPage(page, themeRegistry) {
  return applyThemeLayerToPage(page, "colors", themeRegistry);
}

export function applyShadowsToPage(page, themeRegistry) {
  return applyThemeLayerToPage(page, "shadows", themeRegistry);
}

export function applyRadiusToPage(page, themeRegistry) {
  return applyThemeLayerToPage(page, "radius", themeRegistry);
}


export function resolveAllStyles(page, themeRegistry) {
  let output = page;

  output = applyTypographyToPage(output, themeRegistry);
  output = applyColorsToPage(output, themeRegistry);
  output = applyShadowsToPage(output, themeRegistry);
  output = applyRadiusToPage(output, themeRegistry);

  return output;
}

export function getComputedStyles(element) {
  return {
    ...element.styles.default,
    ...element.styles.theme,
    ...element.styles.custom,
  };
}
export const sampleCards = [
  {
    id: "card-1",
    elements: [
      createElement({ id: "header-1", type: "header", content: "🚀 Launch", styleRole: "heading" }),
      createElement({ id: "para-1", type: "para", content: "Build your school app faster", styleRole: "body" }),
      createElement({ id: "btn-1", type: "btn", content: "Get Started", styleRole: "button" }),
    ],
  },
  {
    id: "card-2",
    elements: [
      createElement({ id: "title-2", type: "title", content: "Features", styleRole: "heading" }),
      createElement({ id: "para-2", type: "para", content: "Smart editor, easy launch", styleRole: "body" }),
      createElement({ id: "icon-2", type: "icon", src: "⚙️", styleRole: "icon" }),
    ],
  },
];